import React, { FC, FocusEvent, ChangeEvent, useState } from 'react'
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'

const CheckboxField:FC<ValueFieldProps> = (props) => {
  const {
    field,
    tracker,
    errors,
    isValid,
    value,
    fieldValidationErrorsComponent,
    onChange,
  } = props

  const [IsChecked, ChangedChecked] = useState(value)

  const FieldValidationErrors = fieldValidationErrorsComponent

  const hasAnyError = !!errors?.length
  const label = field.model.title
  const id = field.valueField.id
  const name = field.valueField.name

  const onFocus = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onFocusField(field, e.target.value)
  }

  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onBlurField(field, e.target.value)
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    ChangedChecked(e.target.checked?.toString())
    onChange(field.valueField.name, e.target.checked?.toString(), isValid, [])
  }

  return (
    <div>
      <div
        className={`sitecore-jss-form__control sitecore-jss-form__control--checkboxprivacy ${
          hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
        }`}
        id="checkboxprivacy"
      >
        <label htmlFor={id} className="checkboxprivacy-checkbox">
          <input
            id={id}
            name={name}
            className={
              IsChecked === 'true'
                ? 'sitecore-jss-form__control--checkbox checked'
                : 'sitecore-jss-form__control--checkbox'
            }
            onFocus={onFocus}
            onBlur={onBlur}
            type="checkbox"
            onChange={handleChange}
            value={IsChecked}
            checked={IsChecked === 'true'}
          />
        </label>
        <label className="sitecore-jss-form__label--policy">{label}</label>
      </div>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  )
}

export default CheckboxField
